import {Outlet} from "react-router-dom";
import React from "react";

const PublicLayout = () => {
  return <div className='flex-grow-1 pt-3'>
    <Outlet />
  </div>
}
export default PublicLayout
